import { useState } from "react";
import { toast } from "sonner";

export const MapBlock = () => {
  const [allowed, setAllowed] = useState(() => localStorage.getItem("nes-maps-consent") === "yes");

  const enable = () => {
    localStorage.setItem("nes-maps-consent", "yes");
    setAllowed(true);
    toast.success("Karte wird geladen.");
  };

  return (
    <div className="border border-[#24211D]/15 bg-[#FFFFFF] aspect-[4/3] relative overflow-hidden" data-testid="map-block">
      {allowed ? (
        <iframe
          title="Karte: Haarstudio Nes, Heidenpfuhl 7, 50129 Glessen"
          src="https://www.google.com/maps?q=Heidenpfuhl+7,+50129+Glessen&output=embed"
          className="w-full h-full border-0"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      ) : (
        <div className="absolute inset-0 flex flex-col items-center justify-center text-center p-8 bg-[#F4EFE6]">
          <span className="text-[10px] uppercase tracking-[0.2em] text-[#B08D57] font-sans mb-3">Google Maps</span>
          <p className="text-xs text-[#24211D]/70 font-sans leading-relaxed max-w-xs mb-5">
            Aus Datenschutzgründen laden wir die Karte erst nach Ihrer Zustimmung. Dabei werden Daten an Google übertragen.
          </p>
          <button
            onClick={enable}
            data-testid="map-load-btn"
            className="border border-[#B08D57] text-[#B08D57] hover:bg-[#B08D57] hover:text-[#FBF8F3] px-6 py-2.5 text-[11px] uppercase tracking-[0.15em] font-sans transition-colors duration-300"
          >
            Karte laden
          </button>
        </div>
      )}
    </div>
  );
};
